<template>
    <dashboard-layout>
        <currencies-list-card
            :currencies="currencies"
        />
    </dashboard-layout>
</template>

<script>
    import DashboardLayout from "../components/layout/DashboardLayout";
    import BasicCard from "../components/layout/BasicCard";
    import CurrenciesListCard from "../cards/CurrenciesListCard";
    import {mapGetters} from "vuex";
    export default {
        name: "CurrenciesView",
        components: {CurrenciesListCard, BasicCard, DashboardLayout},
        data: function () {
            return {}
        },
        computed: {
            ... mapGetters({
                currencies: 'currencies/currencies'
            })
        }
    }
</script>

<style lang="scss" scoped>

</style>